import { WorkplaceRequestStatus } from '@gettactic/api';
import { FieldValues, UseFormReturn, Path, RegisterOptions } from 'react-hook-form';

// Status options with proper capitalization for display
export const STATUS_OPTIONS = [
  { value: 'open', label: 'Open' },
  { value: 'pending', label: 'Pending' },
  { value: 'closed', label: 'Closed' }
] as const;

// Basic StatusSelect component props
export interface StatusSelectProps {
  value?: WorkplaceRequestStatus;
  onValueChange?: (value: WorkplaceRequestStatus) => void;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
}

// Form-compatible StatusSelect component props
export interface FormStatusSelectProps<T extends FieldValues> {
  form: UseFormReturn<T>;
  name: Path<T>;
  rules?: RegisterOptions<T, Path<T>>;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  isRequired?: boolean;
}
